import React from 'react';

import { logger as LOG } from '@garnish/logger';

import { useEssentialMachines } from '../../EssentialMachines';

// ────────────────────────────────────────────────────────────────────────────────
const logger = LOG.extend('AUTH');
// ────────────────────────────────────────────────────────────────────────────────

export const useSendLogoutToAuthMachine = () => {
  const { authMachineRef } = useEssentialMachines();

  const sendLogoutAction = React.useCallback(
    (csrf?: string) => {
      logger.debug('sending LOGOUT event to AuthMachine', csrf);
      authMachineRef.send({ type: 'LOGOUT', csrfToken: csrf });
    },
    [authMachineRef],
  );

  return sendLogoutAction;
};
